import { QuickbetSelection } from '@core/Areas/Quickbet/types'
import {
  RacingEventType,
  RacingPropositionType,
} from '@core/Areas/VenueMode/Components/Racing/Data/types'
import { FobDetails, FobPropositionSelection } from '@mobi/betslip/types'
import { handleBetSelection } from '@core/Utils/betting/handleBetSelection'
import { VENUE_FEATURE_NAME } from '@core/Areas/VenueMode/constants'

export async function betSelection(
  proposition: RacingPropositionType,
  event: RacingEventType,
  isQuickbet: boolean
) {
  if (!proposition) return

  await handleBetSelection({
    betFlow: { location: isQuickbet ? 'Quickbet' : 'BetSlip' },
    selections: [createBetSelection(proposition, event)],
  })
}

function createBetSelection(
  proposition: RacingPropositionType,
  event: RacingEventType
): QuickbetSelection {
  const selection: FobPropositionSelection = {
    type: 'fob-proposition',
    propositionSeq: proposition.sequence?.toString(),
    priceSource: 'selection',
    winPrice: proposition.winReturn,
    winPriceLastSeen: proposition.winReturn,
    placePrice: proposition.placeReturn,
    placePriceLastSeen: proposition.placeReturn,
  }

  const selectionDetails: FobDetails = {
    // sequence assignment is a little dodgy
    // - name: overloaded to represent the 'competition sequence', which in turn is used to by betslip to determine availability of multis
    // - meetingSeq: left undefined as it's not required for bet placement.. unsure why it exists on 'handleBetSelection'
    event: event.sequence.toString(),

    // naming is a little dodgy, but required for consistency with futures (FR)..
    // - competitionName: not the name of the competition, but instead the competition type, e.g. "Futures"
    // - marketName: use event.name instead of market.name, e.g. "Melbourne Cup" instead of "Winner"
    // - eventName: do not assign (keep as undefined) with actual event name, otherwise the betslip will truncate when it combines competition and event names
    competitionName: VENUE_FEATURE_NAME,
    marketName: event.name,

    propositionName: proposition.description,
    sportIconCode: 'featureraces',
    eventStartTime: event.startTime,
  }

  return {
    bettingType: 'fixed-odds-racing',

    // each way is only supported for FOO, i.e. not FR
    // - also allowing each way causes betslip to remove the event name (referred to as market name) from the slip, i.e. user doesn't know what they are betting on
    shouldAllowPlaceInvestment: false,

    isEachWayAvailable: !!proposition.placeReturn,
    selection,
    selectionDetails,
    betSource: 'venue-mode',
  } as QuickbetSelection
}
